// apps/web/src/lib/auth-client.ts
//
// Better-Auth React client (v1.6.12) bound to the API base URL.
//
// Threat-model link (Plan 04-12a, T-04-12a-01): no session token is ever stored
// in localStorage. Better-Auth's React client uses httpOnly cookies set by the
// Fastify catch-all (/api/auth/*) at the API origin; in dev the Vite proxy
// keeps that same-origin from the browser's perspective.
import { createAuthClient } from "better-auth/react";

// Vite injects VITE_AUTH_BASE_URL at build time. In dev the proxy in
// vite.config.ts forwards /api -> :3000, but Better-Auth still wants a full
// baseURL so it can prefix /api/auth/* itself.
const baseURL = import.meta.env["VITE_AUTH_BASE_URL"] ?? "http://localhost:3000";

export const authClient = createAuthClient({
  baseURL,
  // Cookie-based session is Better-Auth's default; explicit fetchOptions ensures
  // credentials are included on every auth call even when the SPA and API live
  // on different origins in production.
  fetchOptions: {
    credentials: "include",
  },
});

export const { useSession, signIn, signOut, signUp } = authClient;
